import React, { ReactNode } from 'react';

import styled from 'styled-components';

import Header from 'common/Header';
import { AI_FEATURE_GRADIENT } from 'constants/theme';
import { useAppSelector } from 'store/hook';

const CompanyName = styled.div`
  font-size: 14px;
`;

const IconContainer = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  margin-right: 10px;
  background: ${AI_FEATURE_GRADIENT};
  box-shadow: 0 2px 4px 0 var(--box-shadow-pink);
`;

interface Props {
  children?: ReactNode;
}

const CommunitiesToWatchHeader = ({ children }: Props) => {
  const { currentUser } = useAppSelector((state) => state.auth);

  return (
    <Header
      title="Communities to Watch"
      breadcrumbs={<CompanyName>{currentUser?.companyName || ''}</CompanyName>}
      iconComponent={
        <IconContainer>
          <img src="/icons/checklist-white.svg" alt="" height="26px" width="26px" />
        </IconContainer>
      }
    >
      {children}
    </Header>
  );
};

export default CommunitiesToWatchHeader;
